import { render, staticRenderFns } from "./ContestAdd.vue?vue&type=template&id=3bb75502&scoped=true&"
import script from "./ContestAdd.vue?vue&type=script&lang=js&"
export * from "./ContestAdd.vue?vue&type=script&lang=js&"
import style0 from "./ContestAdd.vue?vue&type=style&index=0&id=3bb75502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb75502",
  null
  
)

export default component.exports